import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=669b10de&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=ts&"
export * from "./ProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=669b10de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b10de",
  null
  
)

export default component.exports